export default __webpack_public_path__ + "static/media/birdpicInverted.2217aaa6.png";